const sortConstants = {
  id: 'Id',
  type: 'Type',
  status: 'Status',
  doc_number: 'DocNumber',
  createDate: 'CreateDate',
  DocExecuter: 'DocExecuter',
  ResponsibleWorker: 'ResponsibleWorker',
  DocAuthor: 'DocAuthor',
  address: 'DocAddress',
  topicId: 'TopicId',
  DoneDate: 'DoneDate',
  deadlineDate: 'DeadlineDate',
};
export default sortConstants;
